export const StudentListStyle = {
  list: '',
  listItem:
    'relative rounded-full hover:bg-lightGrey pt-1 pr-12 pb-1 pl-4 mr-5 cursor-pointer',
  activeListItem:
    'relative rounded-full bg-secondaryGreen hover:bg-secondaryGreen pt-1 pr-12 pb-1 pl-4 mr-5 cursor-pointer',
  removeButtonWrapper:
    'absolute right-2 top-0 bottom-0 flex items-center justify-center gap-3',
  removeButton: 'p-0 pt-1.5 pr-1.5 pb-1.5 pl-1.5 min-h-0',
  loaderWrapper: 'w-16',
}
